<template>
  <div>
    <div class="form-group">
      <select 
        id="date_range" 
        class="form-control select2"
        v-model="selectedRangeValue"
      >
        <option value="today">Today</option>
        <option value="this_month">This Month</option>
        <option value="this_quarter">This Quarter</option>
        <option value="this_year">This Year</option>
        <option value="last_7_days">Last 7 Days</option>
        <option value="last_30_days">Last 30 Days</option>
        <option value="custom_date_range">Custom Date Range</option>
      </select>
    </div>
    <div v-if="selectedRangeValue === 'custom_date_range'" id="custom_date_range">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="date_from" class="control-label text-white">From</label>
            <input 
              v-model="dateFrom" 
              type="date" 
              id="date_from" 
              class="form-control input-sm date-picker"
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="date_to" class="control-label text-white">To</label>
            <input 
              v-model="dateTo" 
              type="date" 
              id="date_to" 
              class="form-control input-sm date-picker"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import 'select2/dist/css/select2.min.css';
import 'select2';
import $ from 'jquery';

const selectedRangeValue = ref('last_30_days');
const selectedRange = ref([formatDate(new Date(new Date().setMonth(new Date().getMonth() - 1))), formatDate(new Date())]);

const dateFrom = ref(selectedRange.value[0]);
const dateTo = ref(selectedRange.value[1]);

const emit = defineEmits(['update:selectedRangeValue', 'update:selectedRange']);

function formatDate(date) {
  return date.toISOString().split('T')[0];
}

onMounted(() => {
  // Initialize Select2
  $('#date_range').select2({
    placeholder: "Select a range",
    allowClear: true
  });

  // Set initial value
  $('#date_range').val(selectedRangeValue.value).trigger('change');

  $('#date_range').on('change', (e) => {
    selectedRangeValue.value = $(e.target).val();
  });
});

watch(selectedRangeValue, (newRange) => {
  if (newRange !== 'custom_date_range') {
    selectedRange.value = newRange;
    emit('update:selectedRangeValue', selectedRangeValue.value);
    emit('update:selectedRange', selectedRange.value);
  }
});

watch([dateFrom, dateTo], ([newDateFrom, newDateTo]) => {
  if (selectedRangeValue.value === 'custom_date_range') {
    selectedRange.value = [newDateFrom, newDateTo];
    emit('update:selectedRangeValue', selectedRangeValue.value);
    emit('update:selectedRange', selectedRange.value);
  }
});
</script>
